import { useCallback, useEffect, useState } from 'react';
import { Landing } from './components/Landing.js';
import { RoomView } from './components/RoomView.js';

const NAME_KEY = 'jam:name';

/**
 * ルーティングはライブラリを入れずに pushState だけで済ませる。
 * 画面は「入口」と「部屋」の2つしかない。
 */
export function App() {
  const [path, setPath] = useState(() => location.pathname);
  const [name, setName] = useState(() => localStorage.getItem(NAME_KEY) ?? '');

  useEffect(() => {
    const onPop = () => setPath(location.pathname);
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const navigate = useCallback((to: string) => {
    history.pushState(null, '', to);
    setPath(to);
  }, []);

  const saveName = useCallback((value: string) => {
    setName(value);
    localStorage.setItem(NAME_KEY, value);
  }, []);

  const roomCode = /^\/r\/(\d{4})$/.exec(path)?.[1];

  // 名前を決める前に部屋のURLを直接開いた場合は、先に名前を聞く
  if (roomCode && name.trim()) {
    return (
      <RoomView
        roomCode={roomCode}
        name={name}
        onLeave={() => navigate('/')}
        onRename={saveName}
      />
    );
  }

  return (
    <Landing
      name={name}
      onNameChange={saveName}
      pendingRoomCode={roomCode ?? null}
      onEnterRoom={(code) => navigate(`/r/${code}`)}
    />
  );
}
